import React, { useEffect, useState } from "react";
import axios from "axios";
import { Gift, Copy, Check } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Share the app, earn free questions — one per new friend who opens your link.
export const InviteFriend = ({ compact = false }) => {
  const { lang } = useI18n();
  const [ref, setRef] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/referral/me`, { withCredentials: true })
      .then(r => { if (alive) setRef(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!ref) return null;

  const msg = `${ref.text} ${ref.link}`;
  const open = (url) => window.open(url, "_blank", "noopener");
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(msg);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch { /* link is on screen anyway */ }
  };

  const btn = {
    display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "7px",
    padding: "10px 16px", borderRadius: "40px", fontSize: "0.82rem", fontWeight: 700,
    cursor: "pointer", border: "1px solid rgba(255,209,102,0.4)", color: "#FFD166",
    background: "rgba(255,209,102,0.1)", textDecoration: "none",
  };

  return (
    <div data-testid="invite-friend-card" className="glass-card animate-fadeInUp" style={{
      marginBottom: compact ? "18px" : "22px", padding: "16px 18px",
      border: "1px solid rgba(255,209,102,0.3)",
      background: "linear-gradient(135deg, rgba(255,209,102,0.1), rgba(157,78,221,0.07))",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
        <Gift size={15} style={{ color: "#FFD166" }} />
        <span className="font-cinzel" style={{ color: "#FFD166", fontSize: "0.98rem" }}>
          {lang === "hi" ? "दोस्त को भेजें, मुफ़्त सवाल कमाएँ" : "Invite a friend, earn free questions"}
        </span>
      </div>
      <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "0.82rem", lineHeight: 1.65, margin: "0 0 12px" }}>
        {lang === "hi"
          ? `हर नए दोस्त के लिंक खोलने पर आपको 1 मुफ़्त AI सवाल मिलता है (अधिकतम ${ref.cap})।`
          : `Every new friend who opens your link earns you 1 free AI question — up to ${ref.cap}.`}
      </p>

      <div data-testid="invite-stats" style={{ display: "flex", gap: "18px", flexWrap: "wrap", marginBottom: "13px" }}>
        {[
          [lang === "hi" ? "खोले गए" : "Friends opened", ref.opens],
          [lang === "hi" ? "कमाए" : "Questions earned", `${ref.earned}/${ref.cap}`],
          [lang === "hi" ? "उपलब्ध" : "Ready to use", ref.available],
        ].map(([label, value]) => (
          <div key={label}>
            <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "0.68rem", textTransform: "uppercase", letterSpacing: "0.4px" }}>{label}</div>
            <div data-testid={`invite-stat-${String(label).toLowerCase().replace(/\s+/g, "-")}`} style={{ color: "#FFD166", fontWeight: 700, fontSize: "1rem" }}>{value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        <button data-testid="invite-whatsapp-btn" style={{ ...btn, background: "rgba(37,211,102,0.16)", borderColor: "rgba(37,211,102,0.45)", color: "#86efac" }}
          onClick={() => open(`https://wa.me/?text=${encodeURIComponent(msg)}`)}>WhatsApp</button>
        <button data-testid="invite-x-btn" style={btn}
          onClick={() => open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(ref.text)}&url=${encodeURIComponent(ref.link)}`)}>Post on X</button>
        <button data-testid="invite-copy-btn" style={btn} onClick={copy}>
          {copied ? <><Check size={14} /> {lang === "hi" ? "कॉपी हुआ" : "Copied"}</> : <><Copy size={14} /> {lang === "hi" ? "लिंक कॉपी" : "Copy link"}</>}
        </button>
      </div>
    </div>
  );
};

export default InviteFriend;
